var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#3273FA",
    width: 30,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08 10.5V5.71l.03-.005L8.975 10.5H10.4V3.39H8.976v4.786l-.03.005L6.08 3.39H4.654V10.5H6.08zm10.19 0V9.406h-3.134V7.375h2.636V6.276h-2.636V4.49h3.125V3.391H11.71V10.5h4.56zm3.428 0l1.304-4.683h.03L22.34 10.5h1.323l1.66-7.11h-1.47l-.942 4.825h-.03L21.594 3.39H20.44L19.161 8.21h-.03l-.946-4.82h-1.47l1.66 7.11h1.323z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default __webpack_public_path__ + "static/svg/new-tag.svg";
export { SvgNewTag as ReactComponent };